<template>
  <div>
    <el-aside width="auto" background-color="#FFFFFF" text-color="#4B5769">
      <el-menu
        :collapse="isCollapse"
        :default-active="activeMenu"
        :router="true"
        @select="select"
        @open="open"
        :unique-opened="true"
        class="el-menu-vertical-demo"
      >
        <el-submenu
          :index="`${item.title}`"
          v-for="(item, index) in list"
          :key="index"
        >
          <template slot="title"
            ><i
              :class="actTitle == item.title ? item.icon + 'Act' : item.icon"
            ></i
            ><span
              slot="title"
              :class="{ activeTitle: actTitle == item.title }"
              >{{ item.title }}</span
            ></template
          >
          <el-menu-item
            :index="`${item2.path.split('/')[1]}`"
            @click="go(item2.path)"
            v-for="(item2, index2) in item.children"
            :key="index2"
            >{{ item2.title }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
      <div class="collapse">
        <i
          :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          @click="isCollapse = !isCollapse"
        ></i>
      </div>
    </el-aside>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      isCollapse: false,
      list: [
        {
          title: '学校活跃数据',
          icon: 'el-icon-my-school',
          children: [
            {
              title: '整体活跃',
              path: '/allActive'
            },
            {
              title: '作业分析',
              path: '/homeworkAnalysis'
            },
            {
              title: '课件分析',
              path: '/couserwareAnalysis'
            },
            {
              title: '作业监测',
              path: '/workMonitor'
            }
          ]
        },
        {
          title: '题库使用数据',
          icon: 'el-icon-my-questionData',
          children: [
            {
              title: '区域题库分析',
              path: '/regionalQuestion'
            },
            {
              title: '学校题库分析',
              path: '/schoolQuestion',
              children: [
                {
                  title: '学校题库分析',
                  path: '/schoolQuestion'
                }
              ]
            }
          ]
        }
      ],
      actTitle: '学校活跃数据',
      actPath: ''
    }
  },
  computed: {
    menuList() {
      return this.$store.state.routes[0].children || []
    },
    activeMenu() {
      //为了进入三级菜单时候,二级菜单是激活状态,进行分割匹配
      this.actPath = this.$route.path.split('/')[1]
      this.actTitle = this.activeFirstMenu(this.list)
      return this.$route.path.split('/')[1]
    }
  },
  created() {
    // 页面刷新后，store 中的数据会丢失不见，这个时候需要从 session 中获取
    const menu = JSON.parse(sessionStorage.getItem('menu'))
    if (menu) this.$store.commit('SET_ROUTES', menu)
  },
  methods: {
    go(path) {
      this.$router.push({
        path
      })
    },
    select(index, indexPath, index2, path) {
      // console.log(indexPath);
      // this.actTitle = indexPath[0]
    },
    open(index, indexPath, index2, path) {
      // console.log(index,indexPath,index2,path,'open');
    },
    // 定义方法通过$route.path匹配需要活跃的父标签
    activeFirstMenu(list) {
      for (const item of list) {
        if (item.children.length > 0) {
          let index = item.children.findIndex(
            el => el.path.split('/')[1] == this.actPath
          )
          if (index != -1) {
            return item.title
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  height: calc(100vh - 48px);
  position: relative;
  box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.12);
  .el-menu {
    border: none;
    .el-menu-item.is-active {
      border-right: 2px #4a90e2 solid;
      background-color: rgba(74, 144, 226, 0.1);
      span {
        color: #4a90e2 !important;
      }
    }
    .el-menu-item {
      padding-left: 50px !important;
    }
  }
  .collapse {
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 0;
    line-height: 40px;
    padding-left: 18px;
    background-color: #ffffff;
    i {
      cursor: pointer;
      color: rgba(0, 0, 0, 0.45);
      &:hover {
        color: #5a94f6;
      }
    }
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 208px;
  height: calc(100vh - 88px);
  overflow-y: auto;
}
.activeTitle {
  color: #409eff;
}
</style>
